import {
  getAuthorizationHeader,
  URL,
  idEmpresa,
  username,
  codigoFormularioAdelanto,
  codigoFormularioVacaciones,
  codigoFormularioReposoMedico
} from "../../constans/constants";
import Cookies from "universal-cookie";
import axios from "axios";
import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import SolicitudVacaciones from "../tiposFormularios/SolicitudVacaciones";
import AdelantoSalarial from "../tiposFormularios/AdelantoSalarial"
import ReposoMedico from "../tiposFormularios/ReposoMedico";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import Multiselect from "../componentes/forms/Multiselect";
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
} from '../../constans/form-error-utils';
import { update } from "lodash";

export default class NuevoTramite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      generarPdf: false,
      pdfUrl: null,
      miembros: [],
      selectedMiembros: [],
      reporteGuardado: false,
      tipoFormulario: null,
      errors: {
        tramiteSeleccionado: null,
        multiselect: null,
      },
      campos: {},
      tramiteSeleccionado: "",
      nombreTramiteSeleccionado: "",
      openPantallaCarga: false,
      validated: false,
      showValidacion: false,
      erroresValidacion: null,
      memberOptions: [],
      idTramiteGuardado: null,
      idFormularioSeleccionado: null,
      touched: false,
      formularioSeleccionado: null,
      tipoTramiteCargado: false,
    };
  }

  componentDidMount() {

    configurarLimpiezaAutomatica()

    this.fetchMiembros()

    let formularioSeleccionado = localStorage.getItem("formularioSeleccionado")

    if (formularioSeleccionado)
      this.setState({ formularioSeleccionado: JSON.parse(formularioSeleccionado) })
    else
      localStorage.removeItem("formularioSeleccionado")
  }

  fetchMiembros = async () => {
    try {
      const cookies = new Cookies();
      const response = await axios.get(
        URL +
        "organizacion/miembrosUnidadPadre/" +
        cookies.get("username") +
        "/" +
        cookies.get("empresa"),
        getAuthorizationHeader()
      );
      this.setState({ miembros: response.data.datos });
    } catch (error) {
      console.error("Error al obtener los miembros:", error);
    }
    const miembroOptions = this.state.miembros.map((miembro) => ({
      value: miembro.id,
      label: `${miembro.name} ${miembro.lastname}`,
    }));
    this.setState({ memberOptions: miembroOptions });
  };

  handleMiembroChange = (selectedOptions) => {
    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        selectedMiembros: null,
      },
      selectedMiembros: selectedOptions,
    }));
  };

  validarCamposFormulario = () => {
    if (this.state.selectedMiembros.length <= 0) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          multiselect: "Debe seleccionar uno o varios destinatarios",
        }
      }));
      return { isValid: false, errors: this.state.errors }
    }
    return { isValid: true, errors: [] }
  }


  guardarTramite = (event) => {
    event.preventDefault();
    const { isValid, errors } = this.validarCamposFormulario();
    if (isValid) {
      mostrarErroresEnFormulario({});
      this.setState({ openPantallaCarga: true });
      const url = URL + "tramite/agregar";
      const listMiembros = this.state.selectedMiembros.map((miembro) => ({
        id: miembro.value,
      }));
      const bodyRequest = {
        nombre: this.state.formularioSeleccionado.nombre,
        empresa: idEmpresa(),
        username: username(),
        campos: JSON.stringify(this.state.campos),
        supervisores: listMiembros,
        tipoDocumento: this.state.formularioSeleccionado.id,
      };
      axios
        .post(url, bodyRequest, getAuthorizationHeader())
        .then((response) => {
          this.props.history.push({
            pathname: '/tramite/import/' + (response.data.error ? 'error' : 'exito'),
            state: {
              nombreDocumento: response.data.datos.nombre,
              destinatario: this.state.selectedMiembros.map((e) => e.label),
              errorDetalle: response.data.mensaje,
              backURL: this.props.location.pathname,
              urlSiguiente: '/tramites/firma/false/' + response.data.datos.id
            }
          })
        })
        .catch((error) => {
          console.error("Error al descargar el recibo:", error);
        });
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }

  };

terminarCargaDatos = (pdfBase64, bodyRequest) => {
  const { isValid, errors } = this.validarCamposFormulario();
  if (isValid) {
    mostrarErroresEnFormulario({});
    // No llamar updatePDFViewer acá: el iframe no existe todavía en el DOM.
    // El onLoad del iframe lo llamará cuando viewer.html esté listo.
    this.setState({ pdfUrl: pdfBase64, campos: bodyRequest });
  } else {
    this.setState({ errors: errors, showErrors: true });
    mostrarErroresEnFormulario(errors, document.querySelector('.seleccionDestinatarios'));
  }
}

handleViewerLoad = () => {
  if (this.state.pdfUrl) {
    this.updatePDFViewer(this.state.pdfUrl);
  }
}


/*updatePDFViewer = (base64Data) => {
  const viewerFrame = document.getElementById('pdf-js-viewer');
  if (viewerFrame) {
    viewerFrame.onload = () => {
      try {
        const viewerWindow = viewerFrame.contentWindow;
        if (viewerWindow.PDFViewerApplication) {
          viewerWindow.PDFViewerApplication.initializedPromise.then(() => {
            const cleanBase64 = base64Data.replace(/^data:application\/pdf;base64,/, '');
            const binary = atob(cleanBase64);
            const len = binary.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              bytes[i] = binary.charCodeAt(i);
            }

            // Ahora abrimos el PDF con data en binario
            viewerWindow.PDFViewerApplication.open({ data: bytes });
          }).catch(err => {
            console.error("Error inicializando PDFViewerApplication:", err);
          });
        }
      } catch (error) {
        console.error('Error al cargar PDF:', error);
      }
    };
  }
};*/

  updatePDFViewer = async (pdfData) => {

    const viewerFrame = document.getElementById('pdf-js-viewer');

    if (!viewerFrame) {
      console.error('No existe pdf-js-viewer');
      return;
    }

    try {

      const viewerWindow = viewerFrame.contentWindow;

      if (!viewerWindow.PDFViewerApplication) {
        console.error('PDFViewerApplication no disponible');
        return;
      }

      await viewerWindow.PDFViewerApplication.initializedPromise;

      let bytes;

      if (
          typeof pdfData === 'string' &&
          (pdfData.startsWith('JVBER') || pdfData.startsWith('data:application/pdf;base64,'))
      ) {

        const cleanBase64 = pdfData
            .replace(/^data:application\/pdf;base64,/, '')
            .replace(/\s/g, '');

        const binary = atob(cleanBase64);

        bytes = new Uint8Array(binary.length);

        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }

      }


      else if (
          typeof pdfData === 'string' &&
          pdfData.startsWith('blob:')
      ) {

        const response = await fetch(pdfData);

        const blob = await response.blob();

        const arrayBuffer = await blob.arrayBuffer();

        bytes = new Uint8Array(arrayBuffer);

      }

      else {
        console.error('Formato PDF no soportado', pdfData);
        return;
      }


      await viewerWindow.PDFViewerApplication.open({
        data: bytes
      });

      console.log('PDF cargado correctamente');

    } catch (error) {
      console.error('Error al cargar PDF:', error);
    }
  };




  renderizarFormulario = (tipoFormulario) => {
    switch (tipoFormulario) {
      case codigoFormularioAdelanto:
        return (
          <AdelantoSalarial
            terminarCargaDatos={this.terminarCargaDatos}
            cerrarDialogo={this.props.handleClose}
            tramite={this.state.tramiteSeleccionado}
            idFormulario={this.state.formularioSeleccionado.id}
          />)

      case codigoFormularioVacaciones:
        return (
          <SolicitudVacaciones
            terminarCargaDatos={this.terminarCargaDatos}
            cerrarDialogo={this.props.handleClose}
            tramite={this.state.tramiteSeleccionado}
            idFormulario={this.state.formularioSeleccionado.id}
          />)
      case codigoFormularioReposoMedico:
        return (
          <ReposoMedico
            terminarCargaDatos={this.terminarCargaDatos}
            cerrarDialogo={this.props.handleClose}
            tramite={this.state.tramiteSeleccionado}
            idFormulario={this.state.formularioSeleccionado.id}
          />)

      default:
        break;
    }

  }

  renderizarFormularioCarga = () => {
    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={"/tramites/generar"}
              breadcrumbs={[{ label: 'Iniciar solicitud', path: '/tramites/generar' },
              { label: this.state.formularioSeleccionado.nombre, path: '' }
              ]}
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title">Formulario de {this.state.formularioSeleccionado.nombre}</h1>
                <p className="page-description">Complete el siguiente formulario con los datos correspondientes</p>
              </div>
            </div>
          </div>
        </header>

        <div className="wrapperContent">
          <div className="component-form">
            <div className="page-container">

              <div className="component-content card">
                <div className="form container-sm">
                  <form className="seleccionDestinatarios">
                      <Multiselect
                        options={this.state.memberOptions}
                        initialValues={[]}
                        onChange={this.handleMiembroChange}
                        placeholder="Seleccionar destinatarios"
                        name="multiselect"
                      />
                  </form>
                  <hr />

                  {this.renderizarFormulario(this.state.formularioSeleccionado.codigoFormulario)}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )

  }

  renderizarFormSolicitudCargada = () => {

    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={"/tramites/generar"}
              breadcrumbs={[{ label: 'Iniciar solicitud', path: '/tramites/generar' },
              { label: 'Solicitud de vacaciones', path: '' }
              ]}
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title">Confirmar datos de Solicitud</h1>
                <p className="page-description">Hemos generado el siguiente documento con los datos ingresados, confírmalos para enviar</p>
              </div>
              <div className="head-actions">
                <button className="btn-medium btn-base"> Atras </button>
                <button onClick={this.guardarTramite} className="btn-medium btn-primary"> Confirmar documento </button>
              </div>
            </div>
          </div>
        </header>
        <div className="wrapperContent">

<div id="component-documento" style={{ height: "100vh" }}>
  <div className="page-container container-sm" style={{ height: "100%" }}>
    <div className="card" style={{ height: "100%" }}>
      <div id="container-file" style={{ height: "100%" }}>
 <iframe
                    id="pdf-js-viewer"
                    src="/mirecibo/visor/viewer.html?file="
                    title="webviewer"
                    frameBorder="0"
                    width="100%"
                    height="1000px"
                    onLoad={this.handleViewerLoad}
                  ></iframe>
      </div>
    </div>
  </div>
</div>

        </div>
      </div>
    )
  }

  render() {
    if (!this.state.formularioSeleccionado || !this.state.miembros) {
      return <div>Vuelva a seleccionar tipo de tramite en la pantalla anterior...</div>;
    }

    return (
      this.state.pdfUrl && !this.state.reporteGuardado
        ? this.renderizarFormSolicitudCargada()
        : this.renderizarFormularioCarga()
    );
  }
}
